module.exports = __webpack_public_path__ + "img/compresor-3.6ecd5dfc.png";